import { Injectable } from '@angular/core';
import { GlobalService } from "../../common/services/global.service";
import { GlobalVariableService } from "../../common/variables/global-variable";
import { ProjectBrowseOutput } from "../../common/api/ProjectBrowse";
import { ProjectBrowseInput } from "../../common/api/ProjectBrowse";

@Injectable()
export class ManageProjectsAbsService {

  constructor(private globalService: GlobalService, public global: GlobalVariableService,) { }

  public getAllProjects(param: ProjectBrowseInput) {
    const qParam: ProjectBrowseInput = {
      cmd: param.cmd,
      page: param.page
    }
    if (param.name) {
      qParam.name = param.name
    }
    return this.globalService.getData(qParam);
  }

  public getProject(param: any) {
    const qParam: getProjectType = {
      cmd: this.global.projectGet,
      id: param.id
    }
    return this.globalService.getData(qParam);
  }
}

export interface getProjectType {
  cmd: string,
  id: number
}
